// Which site the chat bar is on. This small table is part of agent.js; each site's adapter and
// bridge live in a chunk of their own (dist/sites/<chunk>-<hash>.js), loaded only on that site.
//
// To onboard a site, add its adapter (src/sites/<name>/adapter.js) and a row here. `matches` must
// agree with the adapter's own (tests check it). `aliases` are accepted by data-site="…".

export const SITES = [
  {
    id: 'midi-designer',
    name: 'MIDI',
    chunk: 'midi-designer',
    export: 'midiDesigner',
    aliases: ['midi'],
    matches: [/^https:\/\/midi\.bowdencloud\.com\//, /^http:\/\/(localhost|127\.0\.0\.1):5199\//],
    early: 'midi', // needs a hook before the app boots (see widget/early.js)
  },
  { id: 'planet-ari', name: 'Planet Ari', chunk: 'planet-ari', export: 'planetAri', aliases: ['planets'], matches: [/^https:\/\/planets\.bowdencloud\.com\//] },
  { id: 'genesis-kg', name: 'Genesis Knowledge Graph', chunk: 'kg', export: 'genesisKg', aliases: ['genesis'], matches: [/^https:\/\/genesis\.bowdencloud\.com\//] },
  { id: 'gospels-kg', name: 'Gospels and Acts Knowledge Graph', chunk: 'kg', export: 'gospelsKg', aliases: ['gospels'], matches: [/^https:\/\/gospels\.bowdencloud\.com\//] },
  { id: 'chemfactory', name: 'Forge & Co.', chunk: 'chemfactory', export: 'chemfactory', aliases: ['chemistry', 'forge'], matches: [/^https:\/\/chemistry\.bowdencloud\.com\//] },
  { id: 'planner', name: 'Strategic Planner', chunk: 'planner', export: 'planner', aliases: [], matches: [/^https:\/\/planner\.bowdencloud\.com\//] },
  { id: 'bowdencloud', name: 'bowdenCloud', chunk: 'bowdencloud', export: 'bowdencloud', aliases: [], matches: [/^https:\/\/bowdencloud\.com\//] },
  { id: 'managing-up', name: 'Managing Up', chunk: 'managing-up', export: 'managingUp', aliases: ['manage'], matches: [/^https:\/\/manage\.bowdencloud\.com\//] },
  { id: 'moodbuying', name: 'MoodBuying', chunk: 'moodbuying', export: 'moodbuying', aliases: [], matches: [/^https:\/\/(www\.)?moodbuying\.com\//] },
];

export function siteForUrl(url) {
  if (!url) return null;
  return SITES.find((s) => s.matches.some((re) => re.test(url))) ?? null;
}

export function siteById(id) {
  const k = String(id ?? '').trim().toLowerCase();
  if (!k) return null;
  return SITES.find((s) => s.id === k || s.aliases.includes(k)) ?? null;
}
